export default "__VITE_ASSET__20ede720__"